import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import template from './billing.vue';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import GoogleMaps from '../../components/googleMaps';
import { head, forEach, join, groupBy } from 'lodash-es';
import moment from 'moment';

@Component({
    mixins: [template],
    components: {
        UnisProductModal,
        GoogleMaps,
    },
})
export default class Billing extends Vue {
    showErrTip: boolean = false;
    errorText: String = '';

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    goCreditPage() {
        this.$router.replace({
            name: 'Credit',
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/billing/index.ts